import React from "react";
import { observer } from "mobx-react";
import { PhonogramViewStore } from "../../store";
import { PhonogramViewForm } from "./PhonogramViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type PhonogramViewProps = {
  phonogramViewStore: PhonogramViewStore;
};

export const PhonogramView: React.FC<PhonogramViewProps> = observer(
  ({ phonogramViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <PhonogramViewForm
          phonogramViewStore={phonogramViewStore}
          trackName={phonogramViewStore.trackNameValue}
          performersValues={phonogramViewStore.performersValues}
          albumName={phonogramViewStore.albumNameValue}
          publicationYear={phonogramViewStore.publicationYearValue}
          isrc={phonogramViewStore.isrcValue}
          originalProducer={phonogramViewStore.originalProducerValue}
          audioFileFiles={phonogramViewStore.audioFileFiles}
          mainAudio={phonogramViewStore.mainAudioValue}
          linksVisibleColumns={phonogramViewStore.linksVisibleColumns}
          linksSetColumnWiths={(x) => phonogramViewStore.linksSetColumnWiths(x)}
          linksRows={phonogramViewStore.linksRowsDyn}
          notes={phonogramViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            phonogramViewStore.printPhonogram(handlePrint)
          }
          onCancel={() => phonogramViewStore.cancelPhonogram()}
          onEdit={
            phonogramViewStore.isEditEnabled
              ? () => phonogramViewStore.editPhonogram()
              : undefined
          }
          audioFileViewAction={getViewAction(
            (props) => phonogramViewStore.fileDownload(props, "audioFile"),
            (props) => phonogramViewStore.viewFilePdf(props, "audioFile")
          )}
        />
        <ErrorDialog
          open={phonogramViewStore.errorDialogOpened}
          title={phonogramViewStore.errorTitle}
          description={phonogramViewStore.errorDescription}
          onClose={() => phonogramViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={phonogramViewStore.pdfViewerOpen}
          onClose={() => phonogramViewStore.closePdfViewer()}
          pdfUrl={phonogramViewStore.pdfViewerUrl}
          title={phonogramViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
